namespace RedBullMOBILE360.Web.Modules.Common {
    export enum ReportPartType {
        Value = 0,
        Table = 1,
        Attachment = 2
    }
    Serenity.Decorators.registerEnumType(ReportPartType, 'RedBullMOBILE360.Web.Modules.Common.ReportPartType', 'Reports.PartType');
}
